import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { ServiceCategory } from '../../business-entities/service-category';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { CustomPaggerService } from './../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from './../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from './../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from './../../../../../Autofacets-Core/src/app/utils/constant';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { ServiceCategoriesBusinessService } from './../../business-services/service-categories-business.service';
import { AddServiceCategoryComponent } from './add-service-category/add-service-category/add-service-category.component';
import { EditServiceCategoryComponent } from './edit-service-category/edit-service-category/edit-service-category.component';
import { AdminCommonService } from '../../services/admin-common.service';
@Component({
  selector: 'app-servicecategories',
  templateUrl: './service-category.component.html'
})

export class ServiceCategoryComponent implements OnInit, OnDestroy{

  serviceCategories: ServiceCategory[];
  total$: Observable<number>;
  popupCloseResult = false;
  paginationSub: Subscription;
  currentlagSub: Subscription;
  userRoleRightsDetails: UserRoleMenu;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;


  constructor(
    { nativeElement }: ElementRef<HTMLImageElement>,
    public pService: CustomPaggerService,
    private serviceCategoriesService: ServiceCategoriesBusinessService,
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    private userService: UserDataService,
    private adminCommonService :AdminCommonService,
    config: NgbModalConfig,
  ) {
    const supports = 'loading' in HTMLImageElement.prototype;

    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
    this.pService.pageSize = 10;
    this.pService.searchby = ['service'];
    this.pService.searchTerm = '';

    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    if (this.currentlagSub) {
    this.currentlagSub.unsubscribe();
  }
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.ServiceCategory);
    this.pService.dataSource = [];
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.getServiceCategories();
      });
  }


  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

  getServiceCategories() {
    this.spinner.show();
    let language = this.cookieservice.get('userSelectedLanguage')
    this.serviceCategoriesService.getServiceCategories(language).then((response) => {

      if (response.responseCode == Constant.SuccessResponseCode) {
        this.pService.dataSource = response.responseObject;
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.serviceCategories = this.serviceDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      }
      else if(response.responseObject && response.responseObject.errorCount > 0)
      {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.ServiceCategoriesCode) {
          this.spinner.hide();
      }
      }
      this.spinner.hide();
    });
  }
  onAdd() {
    const modalref = this.modalService.open(AddServiceCategoryComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }
  private serviceDataMapper(service: any) {
    let supperArray = [];
    if (service && service.length > 0) {

      for (let index = 0; index < service.length; index++) {
        const element = service[index];

        let single = Object();
        single.rowNumber = this.adminCommonService.currentPageNumber(index);
        single.service = element.service;
        single.logo = (element.logo)?element.logo:'';
        single.id = element.id;
        single.orderNumber = element.orderNumber;
        supperArray.push(single);
      }
    }

    return supperArray;
  }

  gotoEdit(id: any) {
    this.serviceCategoriesService.serviceCategoryId = id;
    const modalref = this.modalService.open(EditServiceCategoryComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }
  deleteServiceCategory(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblServiceCategorySingular"),false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
       // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.adminCommonService.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.serviceCategoriesService.deleteServiceCategories(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblDeletedServiceCategory");
            this.toastr.success(successMsg)
            this.getServiceCategories();
          }
          if (response.responseCode == Constant.ResponseCode) {
            let errorMsg = this.translate.instant("lblDeletedServiceCategoryErrorMsg");
            this.toastr.error(errorMsg);
          }
        });
      }
    });
  }





}
